(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.ramqMoveStatusMessageWebform = {
    attach: function (context) {

      //Accessibilité
      //Déplace le bloc de message récapitulatif des erreur dans le DOM
      //Par défaut, l'encadre d'erreur s'affiche dans la région "page__content-top"
      if (
        ($(context).find(".webform-submission-form").length != 0 ||
          $(context).hasClass("webform-submission-form")) &&
        $(".page__content-top div.alert.alert-danger").length !== 0
      ) {
        // Identifier la boîte récapitulatif d'erreur en attribuant un ID
        $(".page__content-top div.alert.alert-danger").parent("div[role='contentinfo']").attr("id", "recapitulatif-erreurs");

        /* Histoire 195087
            * Manipuler HTML de la liste des erreurs dans le cas où il y a un lien vers une définition.
          * S'il y a un lien vers une définition, on retire la balise hyperlien.
            *
          */
        // Identifier l'hyperlien vers une définition avec l'assignation d'une classe css.
        $('#recapitulatif-erreurs').find('a[href^="/fr/definition"], a[href^="/en/definition"]').addClass("erreur-definition");
        // Retirer les span.sr-only avant de copier le texte.
        $('.erreur-definition span.sr-only').remove();
        // Pour tous les liens vers une définition
        $('.erreur-definition').each(function () {
          // Isoler le libellé textuel COMPLET du champ
          var libelle_champ = $(this).parents("li").text();
          // Remplacer le HTML de l'hyperlien qui sert d'ancre par le libellé du champ, pour retirer l'hyperlien vers la définition
          $(this).siblings('a[href^="#"]').html(libelle_champ);
          var ancre_libelle_champ = $(this).siblings('a[href^="#"]');
          // Remplacer le HTML de l'élément de la liste (<li>) par l'hyperlien de l'ancre
          $(this).parents('li').html(ancre_libelle_champ);
        });

        var blocMessageErreur = $("#recapitulatif-erreurs");

        // Accessibilité - changer le role pour region + supprimer le role alerte de la boite erreur
        $("div[role='contentinfo']").attr('role', "region");
        $(".alert-danger").removeAttr("role");

        var texteMessageErreur = blocMessageErreur[0].innerHTML;
        //Rétirer et réinjecter le texte dans le div role=alert
        //pour qu'il soit lu par les lecteurs d'écrans
        blocMessageErreur.html("");
        blocMessageErreur.html(texteMessageErreur);

        var form = "form.webform-submission-form";

        //S'il y a un surtitre, c'est que nous ne sommes pas à la première page
        if ($(form).find(".h-surtitre").length != 0) {
          if ($(form).find(".titre-niveau1").length != 0) {
            //Placer le bloc de message récapitulatif sous le titre visuellement H1
            $(form)
              .find(".titre-niveau1")
              .once()
              .after(blocMessageErreur);
          } else {
            $(form)
              .find(".webform-button--previous")
              .parent()
              .once()
              .after(blocMessageErreur);
          }
        } else if ($(form).find("h1").length != 0) {
          $(form)
            .find("h1")
            .once()
            .after(blocMessageErreur);

          //Changer le H3 pour un H2 puisqu'il est après un H1
          // Dev : en mode authentifié, le h3 n'est pas généré dans le template
          // donc tester en mode anonyme
          var blocMessageErreurHTML = $(
            form + " div.alert.alert-danger"
          ).html();
          $(form + " div.alert.alert-danger").html(
            blocMessageErreurHTML.replace("h3", "h2")
          );
        }
      }
    }
  };

  /**
   * Retirer la boîte de message d'erreur qui s'ajoute uniquement au fieldset d'ajout de fichiers
   * après validation qui se fait au moment de l'ajout d'un fichier et non au clic du bouton Suivant
   *
   * Éviter le dédoublement de boîte de message d'erreur puisqu'il y en a un pour toute la page du formulaire
   */
  Drupal.behaviors.ramqFieldsetTypeFile = {
    attach: function (context, settings) {
      var divContentinfo = $("input[type='file']").closest("fieldset").find("div[id*='ajax-wrapper'] div[role='contentinfo']");
      if (divContentinfo.find(".alert").length !== 0) {
        divContentinfo.remove();
      }
    }
  };

  Drupal.behaviors.ramqScrollInWebform = {
    attach: function (context) {
      //Accessibilité
      // Scroller au H1 de la page lorsqu'on navigue dans un même webform
      if ($("#ramq-content .webform-submission-form").parents().hasClass("webform-ajax-form-wrapper").length != 0 &&
        $("#ramq-content .webform-submission-form").parents().hasClass("webform-ajax-form-wrapper") == false &&
        $("h1:visible").hasClass("h-surtitre") == true
      ) {
        if ($("#main-content").length == 1) {
          $("html, body")
            .once()
            .animate({
              scrollTop: $("#main-content").offset().top
            });
        }
        if ($("#main-content-focus").length == 1) {
          $("#main-content-focus").trigger("focus");
        }
      }
    }
  };


  /* Formulaire Type
   ** 1. Gestion ajout ou suppression de périodes
   ** 2. Gestion du focus au clic des boutons de suppression d'éléments du formulaire
   ** 3. Gestion du focus et rétroaction au clic des boutons de suppression d'éléments du formulaire
   */
  Drupal.behaviors.ramqFormBtnAjoutSupp = {
    attach: function (context) {
      // RENDRE AJOUT DE FIELDSETS ACCESSIBLE DANS AUTRE CONTEXTE QUE CALCUL JOURS ABSENCE
      // 1. Gestion ajout ou suppression de périodes
      $("fieldset[id^='edit-periodes'] fieldset").each(function (i) {
        var suivant = i + 2;
        var actuel = i + 1;
        var precedent = i;

        var bouton_plus_actuel = $(this).find(
          "input[id^='plus_" + actuel + "']"
        );
        var bouton_plus_precedent = $("input[id^='plus_" + precedent + "']");
        var bouton_moins_actuel = $(this).find(
          "input[id^='moins_" + actuel + "']"
        );
        var bouton_moins_precedent = $("input[id^='moins_" + precedent + "']");
        var cb_suivant = $("input[name='cb_" + suivant + "']");
        var cb_actuel = $("input[name='cb_" + actuel + "']");

        if (bouton_plus_actuel) {
          bouton_plus_actuel.on("click", function () {
            if (cb_suivant && cb_suivant.prop("checked") == false) {
              cb_suivant.click();
              bouton_plus_actuel.addClass("d-none");
              if (bouton_moins_actuel) {
                bouton_moins_actuel.addClass("d-none");
              }
            }
          });
        }

        if (bouton_moins_actuel) {
          bouton_moins_actuel.on("click", function () {
            var aria_live_text = bouton_moins_actuel.attr("data-aria-live");
            $("#drupal-live-announce").html(aria_live_text);
            setTimeout(function () {
              $("#drupal-live-announce").html("");
            }, 4000);
            if (cb_actuel && cb_actuel.prop("checked") == true) {
              cb_actuel.click();
              if (bouton_moins_precedent) {
                bouton_moins_precedent.removeClass("d-none");
              }
              if (bouton_plus_precedent) {
                bouton_plus_precedent.removeClass("d-none");
              }
            }
          });
        }
      });

      // 2. Gestion du focus au clic des boutons d'ajout d'éléments du formulaire
      $(".bouton_plus input[type=button]", context)
        .once()
        .each(function () {
          $(this).on("click", function () {
            var prochainChamp = $(this)
              .parents("fieldset")
              .next("fieldset")
              .find("input")
              .first();
            $(prochainChamp).trigger("focus");
            $(prochainChamp).addClass("focus-visible");
          });
        });

      // 3. Gestion du focus et rétroaction au clic des boutons de suppression d'éléments du formulaire
      $(".bouton_moins input[type=button]", context)
        .once()
        .each(function () {
          $(this).on("click", function () {
            var prochainChamp = $(this)
              .parents("fieldset")
              .prev("fieldset")
              .find("input")
              .last();
            var dateDepartValeur = $(this)
              .parents("fieldset")
              .attr("data-date-depart");

            var ariaLiveTexte = Drupal.t(
              "Period of absence beginning on % is deleted."
            );
            ariaLiveTexte = ariaLiveTexte.replace("%", dateDepartValeur);

            $(prochainChamp).trigger("focus");
            $(prochainChamp).addClass("focus-visible");
          });
        });
    }
  };

  /* Calculette Périodes d'absence
   ** Gestion de la rétroaction au clic des boutons d'ajout ou suppression de périodes du formulaire
   */
  Drupal.behaviors.ramqFormPeriodesAbsences = {
    attach: function (context) {
      var arrPeriodesAbsence = [];

      $(
        "fieldset[id^='edit-periodes'] input[name*='date_de_depart']",
        context
      ).each(function () {
        $(this).on("change", function (event) {
          var dateDepartValeur = $(this)[0].value;
          var boutonSuppEtiquette = Drupal.t("Remove the period of absence %.");
          var numeroPeriode = $(this)
            .parents("fieldset")
            .attr("id")
            .match(/\d+/);
          var ariaLiveTexte = Drupal.t("Period of absence % is deleted.");

          arrPeriodesAbsence[numeroPeriode] = dateDepartValeur;

          if (dateDepartValeur != "") {
            //Préparer la chaîne de caractères pour le aria-label du bouton
            boutonSuppEtiquette = Drupal.t(
              "Remove the period of absence beginning on %."
            );
            boutonSuppEtiquette = boutonSuppEtiquette.replace(
              "%",
              dateDepartValeur
            );
            //Préparer la chaîne de caractères pour le aria-live au clic du bouton
            ariaLiveTexte = Drupal.t(
              "Period of absence beginning on % is deleted."
            );
            ariaLiveTexte = ariaLiveTexte.replace("%", dateDepartValeur);
          } else {
            //Préparer la chaîne de caractères pour le aria-label du bouton
            boutonSuppEtiquette = boutonSuppEtiquette.replace(
              "%",
              numeroPeriode
            );
            //Préparer la chaîne de caractères pour le aria-live au clic du bouton
            ariaLiveTexte = ariaLiveTexte.replace("%", numeroPeriode);
          }

          $("input[id^='moins_" + numeroPeriode + "']").attr(
            "aria-label",
            boutonSuppEtiquette
          );
          $("input[id^='moins_" + numeroPeriode + "']").attr(
            "data-aria-live",
            ariaLiveTexte
          );
        });
      });
    }
  };



  Drupal.behaviors.ramqMoveNextButtonMakeClickableVetements = {
    attach: function (context, settings) {

      $(once(
        'ramqMoveNextButtonMakeClickableVetements',
        'form.webform-submission-demander-le-rembours-vetements-add-form',
        context
      )).each(function () {

        var $form = $(this);
        var debounceTimer = null;
        var $btnOrigParent = null;
        var $btnOrigNext = null;
        var moActive = true;

        // ── Sélecteur bouton Suivant ──────────────────────────────
        function $nextBtn() {
          return $form.find(
            '#edit-actions-wizard-next,' +
            '[data-drupal-selector="edit-actions-wizard-next"],' +
            '.webform-button--next'
          ).first();
        }

        // ── Mémoriser position originale (1 seule fois) ───────────
        function rememberOrigin($btn) {
          if ($btnOrigParent) return;
          $btnOrigParent = $btn.parent();
          $btnOrigNext = $btn.next();
        }

        // ── Remettre à la position originale ─────────────────────
        function restoreOrigin($btn) {
          if (!$btnOrigParent) return;
          if ($btnOrigNext && $btnOrigNext.length && $.contains(document, $btnOrigNext[0])) {
            $btn.insertBefore($btnOrigNext);
          } else {
            $btnOrigParent.append($btn);
          }
        }

        // ── Dernier "+" réellement visible ────────────────────────
        function getLastVisiblePlus() {
          return $form.find('input.bouton_plus_lh').filter(function () {
            var $b = $(this);
            // Vérifier visibilité réelle
            if (!$b.is(':visible')) return false;
            // Vérifier que le wrapper states ne le cache pas
            var hidden = false;
            $b.parents().each(function () {
              var s = $(this).css('display');
              if (s === 'none') { hidden = true; return false; }
            });
            return !hidden;
          }).last();
        }


        var isTabbing = false;
        $(document).on('keydown', function (e) { if (e.key === 'Tab') isTabbing = true; });
        $(document).on('keyup', function (e) { if (e.key === 'Tab') isTabbing = false; });


        // ── Reposition principale ─────────────────────────────────
        function reposition() {
          if (isTabbing) return;

          var $btn = $nextBtn(); if (!$btn.length) return
          if (!$btn.length) return;

          rememberOrigin($btn);

          moActive = false;

          var $plus = getLastVisiblePlus();

          if ($plus.length) {
            // Trouver le container-inline direct du "+"
            var $container = $plus.closest('.container-inline');
            if (!$container.length) {
              $container = $plus.parent();
            }

            // Mettre le container en flex
            $container.css({
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              flexWrap: 'wrap',
              width: 'auto',
              marginBottom: '0'
            });

            // Déplacer Suivant DANS ce container (à la fin)
            $container.append($btn);

            // Style du bouton
            $btn.css({
              position: 'static',
              display: 'inline-block',
              pointerEvents: 'auto',
              visibility: 'visible',
              opacity: '1',
              zIndex: '',
              top: '',
              left: ''
            })
              .prop('disabled', false)
              .removeAttr('disabled');

          } else {
            // Aucun "+" visible → remettre à sa place d'origine
            restoreOrigin($btn);
            $btn.css({
              position: '',
              display: '',
              pointerEvents: '',
              visibility: '',
              opacity: '',
              zIndex: '',
              top: '',
              left: ''
            });
          }

          setTimeout(function () { moActive = true; }, 150);
        }

        // ── Debounce ──────────────────────────────────────────────
        function scheduleReposition() {
          if (debounceTimer) clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            reposition();
            debounceTimer = null;
          }, 60);
        }

        // ── Init ──────────────────────────────────────────────────
        scheduleReposition();

        // ── Events ───────────────────────────────────────────────

        // Clic + ou Supprimer
        $form.on('click.ramqVetements',
          'input.bouton_plus_lh, input[id^="moins_"]',
          function () {
            scheduleReposition();
            setTimeout(scheduleReposition, 100);
            setTimeout(scheduleReposition, 350);
            setTimeout(scheduleReposition, 700);
          }
        );

        // States cb_*
        $form.on('change.ramqVetements', ':input[name^="cb_"]', function () {
          scheduleReposition();
          setTimeout(scheduleReposition, 100);
        });

        // AJAX Drupal
        $form.on('ajaxComplete.ramqVetements', function () {
          scheduleReposition();
          setTimeout(scheduleReposition, 150);
          setTimeout(scheduleReposition, 500);
        });

        // MutationObserver
        if (typeof MutationObserver !== 'undefined') {
          var mo = new MutationObserver(function () {
            if (!moActive) return;
            scheduleReposition();
          });
          mo.observe($form[0], {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['style', 'class']
          });
        }

      }); // each
    }   // attach
  };
  Drupal.behaviors.ramqMoveNextButtonMakeClickableFactures = {
    attach: function (context) {
      $(once(
        'ramqMoveNextButtonMakeClickableFactures',
        'form.webform-submission-demander-le-remb-services-ss-cam-add-form',
        context
      )).each(function () {

        var $form = $(this);

        // ==== Sélecteurs ====
        var NEXT_SEL = '#edit-actions-wizard-next, [data-drupal-selector="edit-actions-wizard-next"]';
        var PLUS_VISIBLE_SEL = 'input.bouton_plus_lh:visible';

        // IMPORTANT: cibler uniquement les fieldsets "facture"
        // Exemple: data-drupal-selector="edit-1er-facture"
        var FACTURE_FIELDSET_SEL = 'fieldset[data-drupal-selector$="-facture"], fieldset[id$="-facture"]';

        // classes à ajouter sur la première / dernière fieldset facture
        var FIRST_FIELDSET_CLASS = 'ramq-first-facture-fieldset';
        var LAST_FIELDSET_CLASS = 'ramq-last-facture-fieldset';

        // ==== State interne ====
        var debounceTimer = null;
        var scriptActive = true;

        function $btnNext() {
          return $form.find(NEXT_SEL).first();
        }

        function resetStyles($btn) {
          if (!$btn || !$btn.length) return;
          $btn.css({
            position: '',
            zIndex: '',
            pointerEvents: '',
          });
        }

        // ajoute les classes sur la 1ère et la dernière fieldset "facture"
        // si une seule facture visible => ONLY FIRST (comme demandé)
        function updateFirstAndLastFieldsetClass() {
          var $all = $form.find(FACTURE_FIELDSET_SEL);
          if (!$all.length) return;

          // Nettoyage sur toutes les factures (visibles + cachées)
          $all.removeClass(FIRST_FIELDSET_CLASS).removeClass(LAST_FIELDSET_CLASS);

          // On privilégie les factures visibles (si #states masque des blocs)
          var $list = $all.filter(':visible');
          if (!$list.length) $list = $all;

          var count = $list.length;
          var $first = $list.first();
          var $last = $list.last();

          // Cas: 1 seule facture visible -> FIRST seulement
          if (count === 1) {
            $first.addClass(FIRST_FIELDSET_CLASS);
            return;
          }

          // Cas: 2+ factures visibles -> FIRST + LAST
          $first.addClass(FIRST_FIELDSET_CLASS);
          $last.addClass(LAST_FIELDSET_CLASS);
        }

        // Vérifie si l'élément est "au-dessus" (pas recouvert)
        function isElementTop(el) {
          if (!el) return true;
          var rect = el.getBoundingClientRect();
          var cx = rect.left + (rect.width / 2);
          var cy = rect.top + (rect.height / 2);
          if (cx < 0 || cy < 0) return true;
          var topEl = document.elementFromPoint(cx, cy);
          return topEl === el || $.contains(el, topEl);
        }

        function forceClickable($btn) {
          if (!$btn || !$btn.length) return;
          $btn.css({
            position: 'relative',
            zIndex: 99,
            pointerEvents: 'auto',
          }).prop('disabled', false);
        }

        // Placeholder: permet de remettre NEXT exactement à sa place d'origine
        function ensureNextPlaceholder($btn) {
          if (!$btn || !$btn.length) return;

          if ($form.find('#ramq-next-placeholder').length) return;

          $('<span id="ramq-next-placeholder" aria-hidden="true" style="display:none"></span>')
            .insertBefore($btn);
        }

        function getPlusBlock($plusBtn) {
          if (!$plusBtn || !$plusBtn.length) return $();

          var $block = $plusBtn.closest('[id^="edit-bouton-plus-"], .container-inline, .js-form-item, .form-group').first();
          if (!$block.length) $block = $plusBtn.parent();
          return $block;
        }

        function reposition() {
          if (!scriptActive) return;

          var $btn = $btnNext();
          if (!$btn.length) return;

          ensureNextPlaceholder($btn);

          $form.find('.js-form-wrapper.ramq-plus-next-inline')
            .removeClass('ramq-plus-next-inline');

          var $plus = $form.find(PLUS_VISIBLE_SEL).last();

          if ($plus.length) {
            var $plusBlock = getPlusBlock($plus);
            if ($plusBlock.length) {

              $btn.insertAfter($plusBlock);

              var $wrapper = $plusBlock.closest('.js-form-wrapper');
              if ($wrapper.length) {
                $wrapper.addClass('ramq-plus-next-inline');
              }

              $plusBlock.css({ width: 'auto', marginBottom: 0 });
            }

            if (!isElementTop($btn[0])) {
              forceClickable($btn);
            } else {
              $btn.prop('disabled', false).css('pointer-events', 'auto');
            }

            scriptActive = false;
            return;
          }

          var $ph = $form.find('#ramq-next-placeholder');
          if ($ph.length) {
            $btn.insertAfter($ph);
            resetStyles($btn);
          }

          $form.find('.js-form-wrapper.ramq-plus-next-inline')
            .removeClass('ramq-plus-next-inline');

          scriptActive = false;
        }

        function scheduleReposition() {
          scriptActive = true;

          if (debounceTimer) clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            updateFirstAndLastFieldsetClass();
            reposition();
            debounceTimer = null;
          }, 40);
        }

        // Initial
        scheduleReposition();

        // Recalcul après clic sur + / supprimer
        $form.on('click.ramqNext', 'input.bouton_plus_lh, input[id^="moins_"]', function () {
          scheduleReposition();
          setTimeout(scheduleReposition, 60);
          setTimeout(scheduleReposition, 160);
        });

        // Recalcul après changement des cb_*
        $form.on('change.ramqNext', ':input[name^="cb_"]', function () {
          scheduleReposition();
          setTimeout(scheduleReposition, 60);
        });

        // Recalcul après AJAX
        $(document).on('ajaxComplete.ramqNext', function () {
          scheduleReposition();
          setTimeout(scheduleReposition, 60);
        });

      });
    }
  };



  /* Formulaire inscrire assurance maladie nouvel arrivant Enfant
   ** 1. Gestion ajout d'un parent
   ** 2. Gestion du focus au clic des boutons de suppression d'éléments du formulaire
   ** 3. Gestion du focus et rétroaction au clic des boutons de suppression d'éléments du formulaire
   */
  Drupal.behaviors.ramqFormAjoutSuppFieldsets = {
    attach: function (context) {

      $(".bouton_plus input[type=button], .bouton_plus_lh", context).each(function (i) {
        var checkbox_associe_name = $(this).attr("data-checkbox-name");
        var checkbox_associe = $("input[type=checkbox][name=" + checkbox_associe_name + "]");

        $(this).on("click", function () {
          if (checkbox_associe && checkbox_associe.prop("checked") == false) {
            checkbox_associe.click();
          }

          var prochainChamp = $(this)
            .parents("fieldset")
            .next("fieldset")
            .find("input:not([type=button])")
            .first();
          $(prochainChamp).trigger("focus");
        });
      });

      $(".bouton_suppression input[type=button], .bouton_suppression_lh input[type=button]", context).each(function (i) {
        var checkbox_associe_name = $(this).attr("data-checkbox-name");
        var checkbox_associe = $("input[type=checkbox][name=" + checkbox_associe_name + "]");

        var aria_live_text = $(this).attr("data-aria-live");

        $(this).on("click", function () {
          if (checkbox_associe && checkbox_associe.prop("checked") == true) {
            checkbox_associe.click();
            //Accessibilité : on annonce la suppression effectuée
            $("#drupal-live-announce").html(aria_live_text);
            setTimeout(function () {
              $("#drupal-live-announce").html("");
            }, 4000);

            var precedentChamp = $(this)
              .parents("fieldset")
              .prev("fieldset")
              .find("input")
              .last();
            $(precedentChamp).trigger("focus");
          }
        });
      });

    }
  };

  /* Mask au champ currency
   ** Activer le inputmask pour tous les champs webform-currency-element
   ** Gestion de la valeur du champ à 0,00
   */
  Drupal.behaviors.ramqFormCurrencyFormat = {
    attach: function (context) {
      if ($(".webform-currency-element:visible").length) {
        $(".webform-currency-element:visible").inputmask();
      }

      $(".webform-currency-element").on("blur", function () {
        var strValeurCurrency = $(this).val();
        strValeurCurrency = strValeurCurrency.replace(",", ".");
        var intValeurCurrency = parseFloat(strValeurCurrency, 10);
        if (intValeurCurrency == 0) {
          $(this).val("");
        }
      });
    }
  };

  //C'est une fonction pour saisir les caractères en majuscules dans les champs. "champ-numero-tvq"
  Drupal.behaviors.ramqWebformConvertToUppercaseTVQ = {
    attach: function (context) {
      $('input.champ-numero-tvq', context).once('ramqWebformConvertToUppercaseTVQ').each(function () {
        $(this).on('input', function () {
          $(this).val($(this).val().toUpperCase());
        });
      });
    }
  };


  Drupal.behaviors.ramqStylesFormulairesSelectOption = {
    attach: function (context) {
      $("option:selected", context).addClass("selected");

      $("select.form-select", context).on("change", function (event) {
        $(this)
          .find("option", context)
          .removeClass("selected");
        $(this)
          .find('option[value="' + event.target.value + '"]', context)
          .addClass("selected");
      });
    }
  };

  Drupal.behaviors.ramqStylesFormulaires = {
    attach: function (context) {
      // Déplace les messages d'erreur au bon endroit dans le DOM et gère le aria-describedby
      $(
        "form.webform-submission-form fieldset > div.card-body.fieldset-wrapper div.form-item.form-item--error:not(.js-form-type-webform-document-file)",
        context
      ).each(function (errorIdx) {
        var erreurs = $(this).find(
          "div.form-item--error-message:not(.ramq-form-item-error)"
        );
        var nouveauBlocErreur =
          '<div id="form-item--error-' +
          errorIdx +
          '" class="form-item--error-message ramq-form-item-error"><ul>';
        var messages = [];
        while (erreurs.length > 0) {
          if (messages.indexOf(erreurs.first().text()) === -1) {
            messages.push(erreurs.first().text());
            nouveauBlocErreur += "<li>" + erreurs.first().text() + "</li>";
          }
          erreurs.first().remove();
          erreurs = $(this).find(
            "div.form-item--error-message:not(.ramq-form-item-error)"
          );
        }
        nouveauBlocErreur += "</ul></div>";

        if (nouveauBlocErreur.indexOf("<ul></ul>") === -1) {
          var newElement;

          if (
            $(this).children("small:has(div.webform-element-description)")
              .length
          ) {
            newElement = $(nouveauBlocErreur).insertAfter(
              $(this)
                .children("small:has(div.webform-element-description)")
                .first()
            );
          } else if ($(this).hasClass("form-check")) {
            newElement = $(nouveauBlocErreur).prependTo($(this));
          } else if (
            $(this)
              .parents("fieldset")
              .hasClass("fieldset-telephone")
          ) {
            if (
              $(this)
                .parents(".fieldset-telephone:not(.webform-type-fieldset)")
                .find(".form-item--error-message.ramq-form-item-error")
                .length != 0
            ) {
              newElement = $(this)
                .parents(".fieldset-telephone:not(.webform-type-fieldset)")
                .find(".form-item--error-message.ramq-form-item-error")
                .after($(nouveauBlocErreur));
            } else {
              newElement = $(this)
                .parents(".fieldset-telephone:not(.webform-type-fieldset)")
                .prepend($(nouveauBlocErreur));
            }
          } else if (
            $(this)
              .find("input[name$='[other]']:visible")
              .hasClass("error")
          ) {
            $(this).removeClass("form-item--error");
            $(this)
              .find("input[name$='[other]']")
              .parent(".form-group")
              .addClass("form-item--error");
            $(this)
              .find("input[name$='[other]']:visible")
              .attr("aria-describedby", $(nouveauBlocErreur).attr("id"));

            newElement = $(this)
              .find("input[name$='[other]']")
              .parent(".form-group")
              .prepend($(nouveauBlocErreur));
          } else {
            newElement = $(nouveauBlocErreur).insertAfter(
              $(this)
                .children("label")
                .first()
            );
          }

          if (
            $(this)
              .parents("fieldset")
              .hasClass("fieldset--one-question")
          ) {
            $(this)
              .parents("fieldset.fieldset--one-question")
              .attr("aria-describedby", $(nouveauBlocErreur).attr("id"));
          }

          // TODO: Revue
          if (
            newElement &&
            newElement.length &&
            newElement[0].innerText !== ""
          ) {
            var champ = newElement.next("input, textarea");
            if (!champ.length)
              champ = newElement
                .next("div.webform-multiple-table")
                .find("input:visible")
                .first();
            champ.attr(
              "aria-describedby",
              champ.attr("aria-describedby") ?
                champ.attr("aria-describedby") +
                " form-item--error-" +
                errorIdx :
                "form-item--error-" + errorIdx
            );
          }
        }
      });

      $(
        "form.webform-submission-form > div.webform-preview.form-wrapper > div.webform-submission-data--view-mode-preview > details.webform-container.webform-container-type-details.form-wrapper.card",
        context
      ).each(function () {
        $('summary[role="button"]', $(this)).remove();
        $(this).replaceWith(
          $(
            '<div class="webform-container webform-container-type-details form-wrapper card mb-3">' +
            this.innerHTML.replace(/&lt;/g, "<").replace(/&gt;/g, ">") +
            "</div>"
          )
        );
      });

      // Accessibilité - Message d'erreur non lié au groupe de champs « Numéro de téléphone »
      var divMessageErreurID = $("div[id='edit-conteneur-telephone'] div:first-child").attr("id");
      var fieldsetNumeroTelephone = $("#edit-numero-de-telephone").closest("fieldset");
      var attrAriaDescribedByNumeroTelephone = fieldsetNumeroTelephone.attr('aria-describedby') + ' ' + divMessageErreurID;
      fieldsetNumeroTelephone.attr('aria-describedby', attrAriaDescribedByNumeroTelephone);

    }
  };

  Drupal.behaviors.ramqStylesCommunsForm = {
    attach: function (context) {
      // case à cocher Réside à l'extérieur du QC
      // pour cacher le bloc adresse postale
      if ($("input.case_cacher-adresse", context).is(":checked")) {
        var elementParent = $("input.case_cacher-adresse").closest("fieldset");
        elementParent.find("div[id^='edit-container-adresse']").hide();
        $("input.case_cacher-adresse")
          .parent()
          .addClass("mb-0");
      }
      $("input.case_cacher-adresse").on("change", function (event) {
        var elementParent = $(this).closest("fieldset");
        if ($(this).is(":checked")) {
          elementParent.find("div[id^='edit-container-adresse']").hide();
          $(this)
            .parent()
            .addClass("mb-0");
        } else {
          elementParent.find("div[id^='edit-container-adresse']").show();
          $(this)
            .parent()
            .removeClass("mb-0");
        }
        elementParent.find("input[id^='edit-numero-rue']").val("");
        elementParent.find("input[id^='edit-ville']").val("");
        elementParent.find("input[id^='edit-code-postal']").val("");
      });
      $(
        "input[id^='edit-numero-rue'], input[id^='edit-ville'], input[id^='edit-code-postal']"
      ).on("keyup", function (event) {
        var elementParent = $(this).closest("fieldset");
        elementParent.find("input.case_cacher-adresse").prop("checked", false);
      });

    }
  };


  // Dans le formulaire, gère le lien pour les fichiers joints
  Drupal.behaviors.formDocumentFileLinks = {
    attach: function (context) {
      var contextePageFormulaire =
        "form.webform-submission-form .js-form-type-webform-document-file .js-webform-document-file .file a";
      var contexteResumeFormulaire =
        "form.webform-submission-form .webform-preview.form-wrapper .webform-container-type-details .file a";

      $(contextePageFormulaire + ", " + contexteResumeFormulaire)
        .once()
        .each(function (event) {
          $(this).attr("target", "_blank");
          if ($(this).find("img.lien_externe-icone").length == 0) {
            $(this).append(
              '<img alt="" class="icone lien_externe-icone" src="/themes/custom/ramq/assets/images/lien_externe.svg"><span class="sr-only">&nbsp;' +
              Drupal.t("This link will open in a new window.") +
              "</span>"
            );
          }
        });

      // Dans la page résumé seulement, gère l'ouverture des fichiers joints dans une autre fenêtre
      // Copie le behavior de core/modules/file/file.js
      // C'est un comportement déjà en place pour le preview dans le formulaire avant résumé
      $(contexteResumeFormulaire).on("click", function (event) {
        event.preventDefault();
        window.open(
          this.href,
          "filePreview",
          "toolbar=0,scrollbars=1,location=1,statusbar=1,menubar=0,resizable=1,width=500,height=550"
        );
      });
    }
  };


  // @see https://github.com/ractoon/jQuery-Text-Counter#options
  Drupal.webform = Drupal.webform || {};
  Drupal.webform.counter = Drupal.webform.counter || {};
  Drupal.webform.counter.options = Drupal.webform.counter.options || {};

  /**
   * Initialize text field and textarea word and character counter.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.ramqWebformCounter = {
    attach: function (context) {
      if (!$.fn.textcounter) {
        return;
      }

      $(once('webform-counter', '.js-webform-counter', context)).each(function () {
        var options = {
          type: $(this).data('counter-type'),
          max: $(this).data('counter-maximum'),
          min: $(this).data('counter-minimum') || 0,
          counterText: $(this).data('counter-minimum-message'),
          countDownText: $(this).data('counter-maximum-message'),
          inputErrorClass: 'webform-counter-warning',
          counterErrorClass: 'webform-counter-warning',
          countSpaces: true,
          twoCharCarriageReturn: false,
          stopInputAtMaximum: true,
          // Don't display min/max message since server-side validation will
          // display these messages.
          minimumErrorText: '',
          maximumErrorText: ''
        };

        options.countDown = (options.max) ? true : false;
        if (!options.counterText) {
          options.counterText = (options.type === 'word') ? Drupal.t('%d word(s) entered') : Drupal.t('%d character(s) entered');
        }
        if (!options.countDownText) {
          options.countDownText = (options.type === 'word') ? Drupal.t('%d word(s) remaining') : Drupal.t('%d character(s) remaining');
        }

        options = $.extend(options, Drupal.webform.counter.options);

        $(this).textcounter(options);
      });

    }
  };

  // Gère le aria-live pour les textarea
  Drupal.behaviors.ariaLiveTextarea = {
    attach: function (context) {
      $(context)
        .find(
          "form.webform-submission-form .form-item.js-form-type-textarea textarea"
        )
        .once("ariaLiveTextarea")
        .keyup(function () {
          var left = Number($(this).attr("maxlength")) - $(this).val().length;
          if (
            left > 0 &&
            ((left >= 500 && left % 500 === 0) ||
              (left < 500 && left % 250 === 0) ||
              (left < 200 && left % 100 === 0))
          ) {
            Drupal.announce("Il reste " + left + " caractères.");
          }
        });
    }
  };


  // Accessibilité
  // Problème : Au clic d'un champ Autre, un champ texte est activé
  // mais le focus doit rester sur le champ Autre
  // Raison : L'utilisateur doit faire le focus sur le champ texte
  // Solution : remettre le focus sur le champ Autre
  Drupal.behaviors.ChampAutreFocus = {
    attach: function (context) {
      $("input[value=_other_]").on("change", function () {
        var inputName = $(this).attr("name");
        var inputTypeOtherName = inputName.replace(/\[(.*)\]/, "[other]");
        // retirer le width forcé par webform.element.other.js
        $(
          'input[name="' +
          inputTypeOtherName +
          '"], textarea[name="' +
          inputTypeOtherName +
          '"]'
        )
          .parent()
          .css("width", "");
        $(this).trigger("focus");
      });

      $(".js-webform-select-other select").on("change", function () {
        if ($(this).val() == "_other_") {
          $(this)
            .parents(".js-webform-select-other")
            .find(".js-webform-select-other-input")
            .css("width", "");
          $(this).trigger("focus");
        }
      });

      $('input[name$="[other]"], textarea[name$="[other]"]').each(function () {
        $(this)
          .parent("div")
          .css("width", "");
      });
    }
  };

  /* Annoncer le chargement dans aria-live="polite"
   ** - Forcer le focus au bouton d'ajout de fichier après la suppression d'un fichier
   ** - Forcer le focus au bouton de suppresion de fichier après la suppression d'aucun fichier
   ** - Forcer le focus au au dernier fichier ajouté après l'ajout de fichier
   */
  Drupal.behaviors.AddOrRemoveFileFocus = {
    attach: function (context) {
      var nbrFichiersActuel = 0;
      var nbrFichiersAvantChangement = nbrFichiersActuel;

      if (document.activeElement !== null) {
        var documentActiveElementName = document.activeElement.getAttribute(
          "name"
        );

        if (
          documentActiveElementName !== null &&
          documentActiveElementName.match("_remove_button$")
        ) {
          // Forcer le focus au bouton de suppression de fichier
          $("input[name$='_remove_button']").trigger("focus");
          $("input[name$='_remove_button']").addClass("focus-visible");
          $("input[name$='_remove_button']").attr("data-focus-visible-added");
        }
      }

      //Si le bouton de suppression est ajouté au DOM
      $("div[id^='ajax-wrapper']").on("DOMSubtreeModified", function () {
        nbrFichiersActuel = $(".js-webform-document-file")
          .find(".js-form-type-checkbox")
          .children(".form-check-input").length;
        nbrFichiersAvantChangement = nbrFichiersActuel;

        // Annoncer le chargement de la liste des fichiers dans aria-live="polite"
        $("#drupal-live-announce").html(Drupal.t("Loading"));
        setTimeout(function () {
          $("#drupal-live-announce").html("");
        }, 2000);

        setTimeout(function () {
          // Compter le nombre actuel de fichiers après un délai
          // à cause du ajax qui refait le HTML
          nbrFichiersActuel = $(".js-webform-document-file")
            .find(".js-form-type-checkbox")
            .children(".form-check-input").length;

          if (nbrFichiersAvantChangement - nbrFichiersActuel > 0) {
            $("input[name$='_remove_button']").removeClass("focus-visible");
            $("input[name$='_remove_button']").removeAttr(
              "data-focus-visible-added",
              "false"
            );
            // Forcer le focus au bouton d'ajout de fichier
            $(".webform-file-button.button-action").trigger("focus");
            $(".webform-file-button.button-action").addClass("focus-visible");
            $(".webform-file-button.button-action").attr(
              "data-focus-visible-added"
            );
          } else if (nbrFichiersAvantChangement - nbrFichiersActuel < 0) {
            $("input[name$='_remove_button']").removeClass("focus-visible");
            $("input[name$='_remove_button']").removeAttr(
              "data-focus-visible-added",
              "false"
            );
            var dernierFichier = $(
              ".js-form-managed-file .js-form-item:last-of-type input"
            );
            // Forcer le focus au dernier fichier ajouté
            $(dernierFichier).trigger("focus");
            $(dernierFichier).addClass("focus-visible");
            $(dernierFichier).attr("data-focus-visible-added");
          }
        }, 2000);
      });
    }
  };

  /**
   * OVERRIDE pour ajouter l'attribut aria-live="polite"
   * Submit once.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches the behavior for preventing duplicate webform submissions.
   */
  Drupal.behaviors.webformSubmitOnce = {
    attach: function (context) {
      $(".js-webform-submit-once", context).each(function () {
        var $form = $(this);
        // Remove data-webform-submitted.
        $form.removeData("webform-submitted");
        // Remove .js-webform-submit-clicked.
        $form
          .find(".js-webform-wizard-pages-links :submit, .form-actions :submit")
          .removeClass("js-webform-submit-clicked");

        // Track which submit button was clicked.
        // @see http://stackoverflow.com/questions/5721724/jquery-how-to-get-which-button-was-clicked-upon-form-submission
        $form
          .find(".js-webform-wizard-pages-links :submit, .form-actions :submit")
          .on("click", function () {
            $form
              .find(
                ".js-webform-wizard-pages-links :submit, .form-actions :submit"
              )
              .removeClass("js-webform-submit-clicked");
            $(this).addClass("js-webform-submit-clicked");
          });

        $(this).on("submit", function () {
          // Find clicked button
          var $clickedButton = $form.find(
            ".js-webform-wizard-pages-links :submit.js-webform-submit-clicked, .form-actions :submit.js-webform-submit-clicked"
          );

          // Don't submit if client-side validation has failed.
          if (
            !$clickedButton.attr("formnovalidate") &&
            $.isFunction(jQuery.fn.valid) &&
            !$form.valid()
          ) {
            return false;
          }

          // Track webform submitted.
          if ($form.data("webform-submitted")) {
            return false;
          }
          $form.data("webform-submitted", "true");

          // Visually disable all submit buttons.
          // Submit buttons can't disabled because their op(eration) must to be posted back to the server.
          $form
            .find(
              ".js-webform-wizard-pages-links :submit, .form-actions :submit"
            )
            .addClass("is-disabled");

          // Set the throbber progress indicator.
          // Ajout aria-live="polite" pour l'accessibilité
          // @see Drupal.Ajax.prototype.setProgressIndicatorThrobber
          var $progress = $(
            '<div aria-live="polite" class="ajax-progress ajax-progress-throbber"><div class="throbber">&nbsp;</div></div>'
          );
          $clickedButton.after($progress);
        });
      });
    }
  };


  // Évènements liés au champ date
  Drupal.behaviors.ramqDatePicker = {
    attach: function (context) {
      $(context)
        .find(".champ-date")
        .each(function () {
          $(this).on("focusout", function () {
            if (
              $(this)
                .val()
                .trim() !== ""
            ) {
              $(this).val(
                $(this)
                  .val()
                  .trim()
              );
            }
          });
        });
    }
  };


  // Webform demander_remboursement_de_frais
  Drupal.behaviors.ramqWebformDemanderRemboursementFrais = {
    attach: function (context) {
      if ($("form.webform-submission-demander-remboursement-de-frais-form", context).length &&
        $("#edit-pieces-jointes", context).length) {

        $("#edit-pieces-a-joindre-facture-upload-button--2", context).attr(
          "aria-label",
          $("#help-text-file-upload-0", context).text() + $("#help-text-file-upload-1", context).text()
        );

        $("#edit-pieces-a-joindre-preuve-de-paiement-upload-button--2", context).attr(
          "aria-label",
          $("#help-text-file-upload-2", context).text()
        );
      }
    }
  }

  /* Webform na_ecrire
  /* Nous écrire - Preview, cacher les détails vides avec bouton modifier */
  Drupal.behaviors.ramqNousEcrirePreview = {
    attach: function (context) {
      if ($(".webform-submission-data--webform-na-ecrire.webform-submission-data--view-mode-preview").length === 1) {
        $(".webform-container-type-details")
          .once()
          .each(function (index) {
            if ($(this).find("fieldset").length === 0) {
              $(this).addClass("hide-details");
            }
          });
      }
    }
  };

  // Webform na_ecrire
  Drupal.behaviors.ramqStylesFormNousEcrireEmployeurs = {
    attach: function (context) {
      $("#edit-reside-a-exterieur-du-quebec-empl", context).on(
        "change",
        function (event) {
          $("#edit-numero-rue-empl", context).val("");
          $("#edit-ville-empl", context).val("");
          $("#edit-code-postal-empl", context).val("");
          $("#edit-province-empl", context).val("");
          $("#edit-pays-empl", context).val("");
        }
      );
    }
  };

  // Webform denonciation
  Drupal.behaviors.ramqWebformDenonciaton = {
    attach: function (context) {
      if (document.querySelector('form.webform-submission-denonciation-form')) {
        //Bouton Imprimer à la page Résumé
        if (document.getElementById("print-div-button")) {
          const printButton = document.getElementById("print-div-button");
          printButton.addEventListener("click", function () {
            var printContents = document.getElementById("main-content").innerHTML;
            var originalContents = document.body.innerHTML;
            document.body.innerHTML = printContents;
            window.print();
            document.body.innerHTML = originalContents;
          });
        }

        if (document.getElementById("edit-sujet-denonciation")) {
          // Cacher les descriptions qui ne concernent pas la dénonciation
          // selon les réponses fournies
          var i = 0;
          for (i = 0; i < 6; i++) {
            var x = document.getElementById("idr" + i);
            var y = document.getElementById("edit-sujet-denonciation-r" + i);
            if (y && y.checked == false) {
              x.style.display = "none";
            }

          }

          var sujetDenonciationElement = document.getElementById("edit-sujet-denonciation");

          if (sujetDenonciationElement != null) {

            sujetDenonciationElement.addEventListener("change", fnDescription);
            function fnDescription(event) {
              // Cache l'ensemble des éléments
              for (i = 0; i < 6; i++) {
                var x = document.getElementById("idr" + i);
                x.style.display = "none";
              }

              // Rend visible l'élément sélectionné
              var res = event.target.value;
              var x = document.getElementById("id" + res);
              x.style.display = "inline-flex";
            }
          }
        }
      }
    }
  };

  // Demande de révision
  Drupal.behaviors.ramqDemandeRevision = {
    attach: function (context) {
      //console.log("ramqDemandeRevision");
      if (
        $("#edit-q4r1-b-reside-a-exterieur-du-quebec", context).is(":checked")
      ) {
        $("#edit-q4r1-b-container-adresse", context).hide();
        $(this)
          .parent()
          .addClass("mb-0");
      }
      $("#edit-q4r1-b-reside-a-exterieur-du-quebec", context).on(
        "change",
        function (event) {
          if ($(this).is(":checked")) {
            $("#edit-q4r1-b-container-adresse", context).hide();
            $(this)
              .parent()
              .addClass("mb-0");
          } else {
            $("#edit-q4r1-b-container-adresse", context).show();
            $(this)
              .parent()
              .removeClass("mb-0");
          }

          $("#edit-q4r1-b-numero-rue", context).val("");
          $("#edit-q4r1-b-ville", context).val("");
          $("#edit-q4r1-b-code-postal", context).val("");
        }
      );
      $("#edit-q4r1-b-numero-rue", context).on("keyup", function (event) {
        $("#edit-q4r1-b-reside-a-exterieur-du-quebec", context).prop(
          "checked",
          false
        );
      });
      $("#edit-q4r1-b-ville", context).on("keyup", function (event) {
        $("#edit-q4r1-b-reside-a-exterieur-du-quebec", context).prop(
          "checked",
          false
        );
      });
      $("#edit-q4r1-b-code-postal", context).on("keyup", function (event) {
        $("#edit-q4r1-b-reside-a-exterieur-du-quebec", context).prop(
          "checked",
          false
        );
      });
      $("#edit-explication", context).on("focusout", function (event) {
        $("#edit-explication", context).val(
          $("#edit-explication", context)
            .val()
            .trim()
        );
      });
      $("#edit-raison-retard", context).on("focusout", function (event) {
        $("#edit-raison-retard", context).val(
          $("#edit-raison-retard", context)
            .val()
            .trim()
        );
      });

      var dateDecision = $("#edit-date-decision", context)
        .once()
        .val();
      if (
        dateDecision &&
        dateDecision != undefined &&
        dateDecision.trim() != ""
      ) {
        afficherRaisonRetard(dateDecision);
      }
      var dateDecision = $("#edit-date-de-decision-contestee", context)
        .once()
        .val();
      if (
        dateDecision &&
        dateDecision != undefined &&
        dateDecision.trim() != ""
      ) {
        afficherRaisonRetard(dateDecision);
      }

      $("#edit-date-decision", context).on("change", function () {
        var dateDecision = $("#edit-date-decision", context).val();
        afficherRaisonRetard(dateDecision);
      });

      $("#edit-date-de-decision-contestee", context).on("change", function () {
        var dateDecision = $("#edit-date-de-decision-contestee", context).val();
        afficherRaisonRetard(dateDecision);
      });

      function afficherRaisonRetard(dateDecision) {
        if (dateDecision.trim() != "" && dateDecision.trim().length === 10) {
          var res = dateDecision.split("/");
          dateDecision = new Date(res[1] + "/" + res[0] + "/" + res[2]);
          if (dateDecision && dateDecision != undefined) {
            var dateAujourdhui = new Date();
            var jours =
              (dateAujourdhui.getTime() - dateDecision.getTime()) /
              (1000 * 3600 * 24);
            // 6 mois = 182.5 jours en moyenne
            if (jours > 182.5) {
              $("#container-raison-retard", context).css("display", "block");
              $("#edit-temp-raison-retard", context).prop("checked", true);

              $("#edit-textarea-raison-decision-requis-ou-non", context).prop("checked", true);
              $("#edit-textarea-decision-requis-ou-non", context).prop("checked", true);

              $("#container-retard", context).css("display", "block");
            } else {
              $("#container-raison-retard", context).css("display", "none");
              $("#edit-temp-raison-retard", context).prop("checked", false);

              $("#edit-textarea-raison-decision-requis-ou-non", context).prop("checked", false);
              $("#edit-textarea-decision-requis-ou-non", context).prop("checked", false);

              $("#container-retard", context).css("display", "none");
            }
          }
        }
      }

    }
  };

  // Webform form_inscri_assu_arrivant_adulte
  Drupal.behaviors.accessibilite_nouvelarrivant = {
    attach: function (context) {
      if ($("form").hasClass("webform-submission-form-inscri-assu-arrivant-adulte-form")) {
        // Accessibilité - lire la consigne de la question --> Si des membres de votre famille prévoient vous rejoindre plus tard, veuillez cocher « Non ».
        $("#edit-conjoint-enfant-a-charge-non").attr('aria-describedby', "conjoint-enfant-a-charge_consigne");
        $("#edit-conjoint-enfant-a-charge-oui").attr('aria-describedby', "conjoint-enfant-a-charge_consigne");
        //$("#edit-conjoint-enfant-a-charge--wrapper").attr('aria-describedby', "conjoint-enfant-a-charge_consigne"); --> la fieldset qui englobe la question et les boutons radios
      }
    }
  };

  Drupal.behaviors.formValidationInfolettre = {
    attach: function (context, settings) {
      $(document).ready(function () {
        function validateEmail(email) {
          const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          return emailPattern.test(email);
        }

        function validateForm() {
          const emailValue = $('#email').val();
          if (emailValue !== undefined) {
            const email = $('#email').val().trim();
            const emailFilled = email !== '';
            const emailValid = validateEmail(email);
            const checkboxChecked = $('.from_abonnement_aux_infolettres .form-check-input').is(':checked');

            if (emailFilled && emailValid && checkboxChecked) {
              $('#submitInfolettre').removeClass('disabled-btn').prop('disabled', false);
              $('#emailError').hide();
            } else {
              $('#submitInfolettre').addClass('disabled-btn').prop('disabled', true);
              if (!emailValid && emailFilled) {
                $('#emailError').show();

              } else {
                $('#emailError').hide();
              }
            }
          }
        }

        $('#email').on('input', validateForm);
        $('.from_abonnement_aux_infolettres .form-check-input').on('change', validateForm);
        $('#email').insertAfter($('#emailError'));

        //c'est une demande spéciale pour ne pas modifier l'api Cakemail
        //applique comportement de radio sur checknox
        $('#pp_ruptures_de_stock').change(function () {
          if ($(this).is(':checked')) {
            // Action à effectuer lorsque la case est cochée
            $('#Ruptures_de_stock').prop('checked', false);
          }
        });

        $('#Ruptures_de_stock').change(function () {
          if ($(this).is(':checked')) {
            // Action à effectuer lorsque la case est cochée
            $('#pp_ruptures_de_stock').prop('checked', false);
          }
        });

        validateForm(); // Initial validation check
      });
    }
  };


  /**
   * Solution pour résoudre le problème des liens de définition perdant leurs attributs AJAX
   * après l'ajout d'une pièce jointe dans un formulaire Webform sous Drupal 10.
   *
   * Problème :
   * - Lorsqu'une pièce jointe est ajoutée dans un formulaire Webform, le DOM est partiellement
   *   rechargé via AJAX. Cela entraîne la perte des attributs `data-dialog-type`,
   *   `data-dialog-options` et de la classe `use-ajax` nécessaires au fonctionnement des popups.
*/

  Drupal.behaviors.forcePopupBehavior = {
    attach: function (context, settings) {
      // Réappliquer les comportements sur les liens.
      $('a[href^="/fr/definition/"], a[href^="/en/definition/"], a[href^="/fr/definition-pro/"], a[href^="/en/definition-pro/"]', context).has('span').once('force-popup')
        .each(function () {
          $(this)
            .addClass('use-ajax')
            .attr('data-dialog-type', 'colorbox')
            .attr('data-dialog-options', '{"width":300,"dialogClass":"ng-ramq"}');
        });

    }
  };

  /** Poids des fichiers téléchargés - Marker du formulaire SHQ - (Page: Vos factures)
    */
  Drupal.behaviors.poidsTelecharger = {
    attach: function (context) {
      // Only on [data-webform-id="demander_remboursement_shq"] context.
      once('poidsTelecharger', '[data-webform-id="demander_remboursement_shq"]', context).forEach(function (element) {

        // Return early if conditions are not met.
        if ($('.poids-global', element).length < 1) return;
        if ($('.total-poids', element).length < 1) return;
        //console.log('poidsTelecharger', element);

        var totalpiecesjointes = $('.poids-global', element);
        var totalPoidsElement = $('.total-poids', element);
        var poids = parseFloat(totalpiecesjointes.text().trim()).toFixed(2);
        var restant = parseFloat((15 - poids)).toFixed(2);
        var texteActuel = totalPoidsElement.html();

        if (texteActuel && texteActuel.includes('restants')) {
          if (restant < 0) {
            totalPoidsElement.html("0 Mo restants sur 15 Mo");
          } else {
            totalPoidsElement.html(restant + " Mo restants sur 15 Mo");
          }
        } else if (texteActuel && texteActuel.includes('remaining')) {
          if (restant < 0) {
            totalPoidsElement.html("0 MB of 15 MB remaining");
          } else {
            totalPoidsElement.html(restant + " MB of 15 MB remaining");
          }
        }
        totalpiecesjointes.hide();
        // Vérification si le poids est supérieur à 15 (bouton suivant)
        if (parseFloat(poids) > 15) {
          $('#edit-ajouter-facture-preview-next', element).prop('disabled', true);
          $('#edit-suivant-factures-preview-next', element).prop('disabled', true);
          $('.message_erreur_shq_factures', element).show();
        } else {
          $('#edit-ajouter-facture-preview-next', element).prop('disabled', false);
          $('#edit-suivant-factures-preview-next', element).prop('disabled', false);
          $('.message_erreur_shq_factures', element).hide();
        }
        // Désactiver l'ajout d'une facture
        if ($('a.btn.bouton_modifier').length === 4) {
          $('#edit-ajouter-facture-preview-next', element).prop('disabled', true);
        }
      });
    }
  };


  /** Poids des fichiers téléchargés - Marker du formulaire FFPA- (Page: Vos factures)
    */
  Drupal.behaviors.poidsTelechargerFfpa = {
    attach: function (context) {
      // Only on [data-webform-id="demander_remboursement_shq"] context.
      once('poidsTelecharger', '[data-webform-id="ffpa_avec_cam"]', context).forEach(function (element) {

        // Return early if conditions are not met.
        if ($('.poids-global', element).length < 1) return;
        if ($('.total-poids', element).length < 1) return;
        //console.log('poidsTelecharger', element);

        var totalpiecesjointes = $('.poids-global', element);
        var totalPoidsElement = $('.total-poids', element);
        var poids = parseFloat(totalpiecesjointes.text().trim()).toFixed(2);
        var restant = parseFloat((15 - poids)).toFixed(2);
        var texteActuel = totalPoidsElement.html();

        if (texteActuel && texteActuel.includes('restants')) {
          if (restant < 0) {
            totalPoidsElement.html("0 Mo restants sur 15 Mo");
          } else {
            totalPoidsElement.html(restant + " Mo restants sur 15 Mo");
          }
        } else if (texteActuel && texteActuel.includes('remaining')) {
          if (restant < 0) {
            totalPoidsElement.html("0 MB of 15 MB remaining");
          } else {
            totalPoidsElement.html(restant + " MB of 15 MB remaining");
          }
        }
        totalpiecesjointes.hide();
        // Vérification si le poids est supérieur à 15 (bouton suivant)
        if (parseFloat(poids) > 15) {
          $('#edit-ajouter-facture-preview-next', element).prop('disabled', true);
          $('#edit-suivant-factures-preview-next', element).prop('disabled', true);
          $('.message_erreur_ffpa_factures', element).show();
        } else {
          $('#edit-ajouter-facture-preview-next', element).prop('disabled', false);
          $('#edit-suivant-factures-preview-next', element).prop('disabled', false);
          $('.message_erreur_ffpa_factures', element).hide();
        }
        // Désactiver l'ajout d'une facture
        if ($('a.btn.bouton_modifier').length === 3) {
          $('#edit-ajouter-facture-preview-next', element).prop('disabled', true);
        }
        // Désactiver le boutn suivant si aucune facture n'est ajoutée
        if ($('a.btn.bouton_modifier').length === 0) {
          $('#edit-suivant-factures-preview-next', element).prop('disabled', true);
        }
      });
    }
  };

  /**
   * affichage du texte par défaut dans un champ <select> amélioré avec le plugin Chosen.
   */
  Drupal.behaviors.ramqFixChosenDefault = {
    attach: function (context, settings) {
      $('select.chosen-enabled', context).once('fixChosenDefault').each(function () {
        var $select = $(this);

        // Vérifier s’il y a une valeur par défaut sélectionnée
        var defaultText = $select.find('option:selected').text();

        if (defaultText) {
          // Mettre à jour le texte affiché par Chosen
          $select.next('.chosen-container')
            .find('a.chosen-single span')
            .text(defaultText);
        }
      });
    }
  };

  /**
   *  Supprime les balises h2/h3 du titre du résumé d’erreurs lorsqu’il y a plusieurs erreurs pour fixer le bogue d'affichage
   */
  Drupal.behaviors.ramqFixErrorSummaryTitle = {
    attach: function (context, settings) {
      once('ramqFixErrorSummaryTitle', '#recapitulatif-erreurs', context).forEach(function () {
        const $ul = $("#recapitulatif-erreurs .alert > ul", context);
        const $lis = $ul.children("li");

        // Appliquer seulement s'il y a plus d'un <li>
        if ($lis.length > 1) {
          $ul.find("h2.titre-alert, h3.titre-alert, h4.titre-alert").each(function () {
            const text = $(this).text();
            $(this).replaceWith(document.createTextNode(text));
          });
        }
      });
    }
  };


  /**
   *  Accessibilité pour l'élément chosen 'Numero du formulaire' du webform : Envoyer un document à la RAMQ
   */

  Drupal.behaviors.AccessibiliteChampNumeroFormulaire = {
    attach: function (context) {
      once('AccessibiliteChampNumeroFormulaire', context).forEach(function () {

        const chosenContainer = document.getElementById("edit_numero_formulaire_chosen");
        if (!chosenContainer) return;

        const searchInput = chosenContainer.querySelector(".chosen-search-input");
        const nativeSelect = document.getElementById("edit_numero_formulaire");
        const chosenSearchResults = document.getElementById("edit-numero-formulaire-chosen-search-results");

        if (chosenSearchResults) {
          chosenSearchResults.setAttribute("tabindex", "-1");
        }

        if (chosenContainer) {
          chosenContainer.setAttribute("tabindex", "-1");
        }

        if (searchInput) {
          searchInput.setAttribute("tabindex", "0");

          searchInput.addEventListener("focus", () => {
            chosenContainer.classList.add("focus-visible");
          });

          searchInput.addEventListener("blur", () => {
            chosenContainer.classList.remove("focus-visible");
          });
        }

        if (nativeSelect) {
          nativeSelect.setAttribute("tabindex", "-1");
        }
      });
    }
  };

  /**
   *  Cacher le span du mot 'facultatif' du webform : Envoyer un document à la RAMQ
   */

  Drupal.behaviors.cacherSpanFacultatif = {
    attach: function (context) {

      const $select = jQuery('#edit-numero-formulaire', context);
      const $span = jQuery('.changer_a_obligatoire', context);

      if (!$select.length || !$span.length) {
        return;
      }

      function toggleSpan() {
        const valeur = $select.val();

        const valeursCibles = ['1378', '4055', '4059', '4094', '4614', '4552'];

        if (valeursCibles.includes(valeur)) {
          $span.hide();
        } else {
          $span.show();
        }
      }
      // IMPORTANT : exécuter systématiquement après attach
      toggleSpan();

      // éviter duplication d'événements
      $select.off('change.cacherSpanFacultatif')
        .on('change.cacherSpanFacultatif', toggleSpan);
    }
  };

  /**
   * Rend le bouton de sélection du formulaire PDF accessible au clavier + Permet d'ouvrir le sélecteur de fichier avec la touche Entrée.
   */
  Drupal.behaviors.focuserFormulairePDF = {
    attach: function (context) {

      $('.alignement_piece_jointe .webform-file-button', context)
        .attr('tabindex', '0')
        .off('keydown.fichierPDF')
        .on('keydown.fichierPDF', function (e) {

          if (e.key === 'Enter') {
            e.preventDefault();
            this.click();
          }
        });

    }
  };

  /**
 * Déplace le focus automatiquement vers le champ résultat (lecture seule)
 * après le recalcul AJAX du Webform (Calculer la date d’entrée en vigueur de mon nouveau statut).
 *
 * Objectif : améliorer l’accessibilité en permettant aux utilisateurs
 * clavier et lecteurs d’écran d’accéder immédiatement à la valeur calculée.
 */
  Drupal.behaviors.focusResultatCalculDateStatut = {
    attach: function () {
      $(document).ajaxComplete(function () {
        const scrollY = window.scrollY;

        setTimeout(function () {
          const input = document.querySelector('.js-resultat-focus');

          if (input && input.value !== '') {
            input.focus({ preventScroll: true });

            // restauration du scroll pour éviter les sauts visuels
            window.scrollTo(0, scrollY);
          }
        }, 50);
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
